import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Box, TextField, MenuItem, Button, Grid } from "@mui/material";

const UserForm = ({ user, onSubmit, onCancel, roles, onEdit }) => {
  const validationSchema = Yup.object({
    FirstName: Yup.string().required("First Name is required"),
    LastName: Yup.string().required("Last Name is required"),
    EmailAddress: Yup.string()
      .email("Invalid email")
      .required("Email is required"),
    Username: Yup.string().required("Username is required"),
    Password: onEdit
      ? Yup.string()
      : Yup.string().required("Password is required"),
    Role: Yup.string().required("Role is required"),
  });
  const formik = useFormik({
    initialValues: user || {
      FirstName: "",
      LastName: "",
      EmailAddress: "",
      Role: "",
      Username: "",
      Password: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      onSubmit(values);
    },
  });

  return (
    <Box sx={{ mt: 2 }}>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              id="FirstName"
              name="FirstName"
              label="First Name"
              value={formik.values.FirstName}
              onChange={formik.handleChange}
              error={
                formik.touched.FirstName && Boolean(formik.errors.FirstName)
              }
              helperText={formik.touched.FirstName && formik.errors.FirstName}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              id="LastName"
              name="LastName"
              label="Last Name"
              value={formik.values.LastName}
              onChange={formik.handleChange}
              error={formik.touched.LastName && Boolean(formik.errors.LastName)}
              helperText={formik.touched.LastName && formik.errors.LastName}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              id="Username"
              name="Username"
              label="Username"
              value={formik.values.Username}
              onChange={formik.handleChange}
              error={formik.touched.Username && Boolean(formik.errors.Username)}
              helperText={formik.touched.Username && formik.errors.Username}
            />
          </Grid>
          {!onEdit && (
            <Grid item xs={12}>
              <TextField
                fullWidth
                type="password"
                id="Password"
                name="Password"
                label="Password"
                value={formik.values.Password}
                onChange={formik.handleChange}
                error={
                  formik.touched.Password && Boolean(formik.errors.Password)
                }
                helperText={formik.touched.Password && formik.errors.Password}
              />
            </Grid>
          )}
          <Grid item xs={12}>
            <TextField
              fullWidth
              id="EmailAddress"
              name="EmailAddress"
              label="Email Address"
              value={formik.values.EmailAddress}
              onChange={formik.handleChange}
              error={
                formik.touched.EmailAddress &&
                Boolean(formik.errors.EmailAddress)
              }
              helperText={
                formik.touched.EmailAddress && formik.errors.EmailAddress
              }
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              select
              fullWidth
              id="Role"
              name="Role"
              label="Role"
              value={
                formik.values.Role || (roles.length > 0 ? roles[0].ID : "")
              }
              onChange={formik.handleChange}
              error={formik.touched.Role && Boolean(formik.errors.Role)}
              helperText={formik.touched.Role && formik.errors.Role}
            >
              {roles.map((role) => (
                <MenuItem key={role.ID} value={role.ID}>
                  {role.Name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>

        <Box
          sx={{ display: "flex", justifyContent: "flex-end", mt: 3, gap: 1 }}
        >
          <Button variant="outlined" color="error" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="submit" variant="contained" color="error">
            {user ? "Update" : "Create"} User
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default UserForm;
